<template>
  <div class="yc-users">
    <div class="page-head">
      <h2>用户数据</h2>
      <div class="page-actions">
        <el-select v-model="projectFilter" placeholder="全部项目" clearable size="small" style="width: 140px">
          <el-option label="影传" value="影传" />
          <el-option label="影控" value="影控" />
        </el-select>
        <el-input
          v-model="keyword"
          placeholder="搜索相机型号 / 错误码"
          size="small"
          clearable
          style="width: 220px"
          @keyup.enter.native="loadData"
        />
        <el-button type="primary" size="small" :loading="loading" @click="loadData">查询</el-button>
      </div>
    </div>

    <el-table :data="reports" stripe border height="calc(100vh - 230px)" v-loading="loading">
      <el-table-column prop="project_name" label="项目" width="100" align="center">
        <template slot-scope="scope">
          <el-tag size="mini" :type="scope.row.project_name === '影传' ? 'success' : 'warning'">{{ scope.row.project_name }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="camera_model" label="相机型号" width="160" />
      <el-table-column prop="error_code" label="错误码" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.error_code">{{ scope.row.error_code }}</span>
          <span v-else class="muted">-</span>
        </template>
      </el-table-column>
      <el-table-column prop="error_reason" label="错误原因" width="140">
        <template slot-scope="scope">
          <span v-if="scope.row.error_reason">{{ scope.row.error_reason }}</span>
          <span v-else class="muted">-</span>
        </template>
      </el-table-column>
      <el-table-column prop="upload_ok" label="上传状态" width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.upload_ok === 1 ? 'success' : 'danger'" size="mini">
            {{ scope.row.upload_ok === 1 ? '正常' : '失败' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="ip" label="上报IP" width="130" />
      <el-table-column prop="report_date" label="上报日期" width="160" :formatter="fmtCell" />
    </el-table>

    <el-alert
      v-if="usingMock"
      class="todo-tip"
      type="warning"
      :closable="false"
      title="当前为 mock 数据（后端 GET /api/client/reports 未就绪或请求失败）"
      description="已按 API.md 7.3.3 接入：成功时返回 { success:true, data:[{id,ip,project_name,camera_model,error_code,error_reason,upload_ok,report_date,created_at}], pagination }。接口就绪后自动切换为真实数据。"
    />
  </div>
</template>

<script>
import { getReports } from '../../api'
import { formatCST } from '../../utils/format'

// 真实接口未就绪时的兜底 mock（字段与 API.md 7.3.3 返回一致，snake_case）
const MOCK_REPORTS = [
  { id: 1, ip: '1.2.3.4', project_name: '影传', camera_model: 'Canon EOS 6D', error_code: 'Err12', error_reason: 'timeout', upload_ok: 0, report_date: '2026-08-27' },
  { id: 2, ip: '5.6.7.8', project_name: '影控', camera_model: 'Sony A7M4', error_code: '', error_reason: '', upload_ok: 1, report_date: '2026-08-27' },
  { id: 3, ip: '9.10.11.12', project_name: '影传', camera_model: 'Nikon Z6', error_code: 'Err05', error_reason: 'lowBattery', upload_ok: 0, report_date: '2026-08-26' },
  { id: 4, ip: '13.14.15.16', project_name: '影控', camera_model: 'Canon EOS R5', error_code: '', error_reason: '', upload_ok: 1, report_date: '2026-08-26' },
  { id: 5, ip: '17.18.19.20', project_name: '影传', camera_model: 'Canon EOS 6D', error_code: 'Err12', error_reason: 'disconnect', upload_ok: 0, report_date: '2026-08-25' },
]

export default {
  name: 'YcUserData',
  data() {
    return {
      loading: false,
      usingMock: false,
      projectFilter: '',
      keyword: '',
      reports: [],
    }
  },
  methods: {
    fmtCell(row, col, val) {
      return formatCST(val)
    },
    async loadData() {
      this.loading = true
      try {
        const { list } = await getReports({
          project: this.projectFilter,
          keyword: this.keyword,
        })
        this.reports = list
        this.usingMock = false
      } catch (e) {
        // 后端 GET 未实现（404）或网络异常 → 回退 mock，不阻断页面
        this.reports = MOCK_REPORTS.filter((r) => {
          const okProject = !this.projectFilter || r.project_name === this.projectFilter
          const kw = this.keyword.trim().toLowerCase()
          const okKw = !kw || (r.camera_model && r.camera_model.toLowerCase().includes(kw)) || (r.error_code && r.error_code.toLowerCase().includes(kw))
          return okProject && okKw
        })
        this.usingMock = true
      } finally {
        this.loading = false
      }
    },
  },
  created() {
    this.loadData()
  },
}
</script>

<style scoped>
.yc-users {
  padding: 20px;
}
.page-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
.page-head h2 {
  margin: 0;
}
.page-actions {
  display: flex;
  gap: 8px;
}
.todo-tip {
  margin-top: 16px;
}
.muted {
  color: #bbb;
}
</style>



// WEBPACK FOOTER //
// src/admin/views/yingchuan/UserData.vue